import { Factory } from '@infodata-group/inf-commons';
import { Widget } from '../widget/widget';
import { WidgetDto } from '../dto/widget.dto';

export class WidgetFactory implements Factory<Widget> {
  getApi(): string {
    return 'widgets/';
  }
  build(o: WidgetDto): Widget {
    const widget = new Widget(o.id, o.label, o.icon, o.frontId);
    Object.keys(o.settings).forEach((key) => {
      if (o.settings[key]) {
        widget[key] = o.settings[key];
      }
    });
    return widget;
  }
}
